import { toast } from 'react-toastify';
import { NOTIFY } from '@/utils/constant.utils';

export const notify = (message: string, type: string) => {
  switch (type) {
  case NOTIFY.SUCCESS:
    toast.success(message, { className: 'text-primary', progressClassName: 'bg-primary' });
    break;
  case NOTIFY.WARNING:
    toast.warning(message, { className: 'text-primary', progressClassName: 'bg-primary' });
    break;
  case NOTIFY.ERROR:
    toast.error(message, { className: 'text-primary', progressClassName: 'bg-primary' }); 
    break;
  default:
    toast.info(message, { className: 'text-primary', progressClassName: 'bg-primary' });
  }
};
